import { clsx, type ClassValue } from "clsx";
import { createTailwindMerge, getDefaultConfig } from "tailwind-merge";

const customTwMerge = createTailwindMerge(() => {
  const defaultConfig = getDefaultConfig();

  return {
    ...defaultConfig,
    classGroups: {
      ...defaultConfig.classGroups,
      font: [], // disables conflict resolution for font-* classes
    },
  };
});

export function cn(...inputs: ClassValue[]) {
  return customTwMerge(clsx(inputs));
}
